(() => {
 'use strict';
 const parts = now => Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(now).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));
 const key = date => date.toISOString().slice(0,10);
 const add = (date,n=1) => new Date(date.getTime()+n*86400000);
 const easter = year => {
  const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
  return new Date(Date.UTC(year,Math.floor(n/31)-1,n%31+1));
 };
 const holidays = (year,country) => {
  const result=new Set([`${year}-01-01`,`${year}-12-25`]);
  const sunday=easter(year);[1,39,50].forEach(n=>result.add(key(add(sunday,n))));
  if(country==='NL'){
   result.add(`${year}-12-26`);
   let kingsday=new Date(Date.UTC(year,3,27));if(kingsday.getUTCDay()===0)kingsday=add(kingsday,-1);result.add(key(kingsday));
  }
  if(country==='BE')['05-01','07-21','08-15','11-01','11-11'].forEach(day=>result.add(`${year}-${day}`));
  return result;
 };
 const estimate = (now,country,config={}) => {
  const t=parts(now),today=new Date(Date.UTC(t.year,t.month-1,t.day));
  const closures=new Set(String(config.closures||'').split(/[\s,;]+/).filter(Boolean));
  const cache=new Map();
  const working=(date,region)=>{
   const day=date.getUTCDay();if(day===0||day===6||closures.has(key(date)))return false;
   if(!config.holidays)return true;
   const id=date.getUTCFullYear()+region;if(!cache.has(id))cache.set(id,holidays(date.getUTCFullYear(),region));
   return !cache.get(id).has(key(date));
  };
  const advance=(date,region)=>{let next=date;for(let i=0;i<370;i++){if(working(next,region))return next;next=add(next);}return null;};
  const before=t.hour<15&&working(today,'NL');
  const dispatch=advance(before?today:add(today),'NL');if(!dispatch)return null;
  const arrival=advance(add(dispatch),country);if(!arrival)return null;
  return {before,dispatch:key(dispatch),arrival:key(arrival),date:arrival};
 };
 if(typeof module!=='undefined'&&module.exports)module.exports={estimate,parts,holidays};
 if(typeof document==='undefined')return;
 let config={};try{config=JSON.parse(document.getElementById('novo-delivery-settings')?.textContent||'{}');}catch{}
 document.documentElement.classList.add('nf-js');
 document.querySelectorAll('[data-nf-locale]').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit()));
 class NovoDelivery extends HTMLElement {
  connectedCallback(){
   this.variants=[];try{this.variants=JSON.parse(this.querySelector('[data-nd-variants]')?.textContent||'[]');}catch{}
   this.update=this.update.bind(this);
   if(this.dataset.mode==='product'){
    this.root=document.getElementById('Product-'+this.dataset.section)||this.closest('.main-product-section')||this.parentElement;
    this.root.addEventListener('change',this.update);this.root.addEventListener('input',this.update);
    this.observer=new MutationObserver(this.update);this.observer.observe(this.root,{childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled']});
   }
   this.update();
  }
  disconnectedCallback(){this.observer?.disconnect();this.root?.removeEventListener('change',this.update);this.root?.removeEventListener('input',this.update);}
  update(){
   let eligible=this.dataset.eligible==='true';
   if(this.dataset.mode==='product'){
    const form=document.getElementById('product-form-'+this.dataset.section);
    const id=form?.querySelector('[name="id"]')?.value||this.dataset.variant;
    const variant=this.variants.find(v=>String(v.id)===String(id));
    const quantity=Number(form?.querySelector('[name="quantity"]')?.value||this.root?.querySelector('quantity-input input[name="quantity"]')?.value||1);
    const button=form?.querySelector('[name="add"]');
    eligible=eligible&&!!variant?.available&&!!variant?.shipping&&(!variant.tracked||variant.quantity>=quantity)&&!form?.querySelector('[name="selling_plan"]')?.value&&!button?.disabled;
    this.hidden=!eligible;if(!eligible)return;
   }
   const text=this.querySelector('[data-nd-text]'),region=this.querySelector('[data-nd-region]'),info=this.querySelector('[data-nd-info]');if(!text)return;
   let message;
   if(!eligible){message=this.querySelector('[data-nd-mixed]').content.textContent;region.hidden=true;info.hidden=false;}
   else if(!['NL','BE'].includes(this.dataset.country)){message=this.querySelector('[data-nd-international]').content.textContent;region.hidden=true;info.hidden=false;}
   else{
    const result=estimate(new Date(),this.dataset.country,config);if(!result)return;
    const language=this.dataset.locale.startsWith('nl')?'nl-NL':'en-GB';
    const day=new Intl.DateTimeFormat(language,{weekday:'long',timeZone:'UTC'}).format(result.date);
    message=(result.before?this.dataset.before:this.dataset.after).replace('__DAY__',day);region.hidden=false;info.hidden=true;
   }
   if(text.textContent!==message)text.textContent=message;
  }
 }
 if(!customElements.get('novo-delivery'))customElements.define('novo-delivery',NovoDelivery);
 const refresh=()=>document.querySelectorAll('novo-delivery').forEach(element=>element.update?.());
 setInterval(refresh,60000);document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
 document.addEventListener('shopify:section:load',refresh);
 document.addEventListener('click',event=>{const link=event.target.closest('a[href="#novo-order-tracking"]');if(link){const target=document.getElementById('novo-order-tracking');if(target)target.open=true;}});
 class NovoAnnouncement extends HTMLElement {
  connectedCallback(){
   this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.focused=false;
   this.slides=[...this.querySelectorAll('[data-na-slide]')];this.button=this.querySelector('[data-na-pause]');this.button.hidden=false;this.button.setAttribute('aria-pressed',String(this.paused));
   this.button.onclick=()=>{this.paused=!this.paused;this.button.setAttribute('aria-pressed',String(this.paused));this.schedule();};
   this.onmouseenter=()=>{this.hovered=true;this.schedule();};this.onmouseleave=()=>{this.hovered=false;this.schedule();};
   this.onfocusin=()=>{this.focused=true;this.schedule();};this.onfocusout=event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.schedule();}};
   this.visibility=()=>this.schedule();document.addEventListener('visibilitychange',this.visibility);this.schedule();
  }
  schedule(){clearTimeout(this.timer);if(this.paused||this.hovered||this.focused||document.hidden)return;this.timer=setTimeout(()=>{this.index=(this.index+1)%this.slides.length;this.slides.forEach((slide,index)=>{const active=index===this.index;slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;});this.schedule();},10000);}
  disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('visibilitychange',this.visibility);}
 }
 if(!customElements.get('novo-announcement'))customElements.define('novo-announcement',NovoAnnouncement);
})();
